export default __webpack_public_path__ + "static/media/maure_de_bretagne4.3dd4df42.jpg";